// import React, { useEffect, useState, useMemo } from "react";
// import { useAuth } from "../../../Utility/AuthProvider";
// import { useSettings } from "../../../Contexts/SettingsContext";
// import { AppSettings } from "../../../Contexts/SettingsContext";
// import {
//   useReportsData,
//   useUpdateReportsData,
//   Loading,
//   formatAmount,
//   debugAmountValues,
//   debugSelectedTenant,
// } from "../../../Contexts/ReportsContext";
// import { useCallback } from "react";

// // 🔥 IMPORT ALL REQUIRED COMPONENTS
// import Paid from "./Paid";
// import OverdueStatus from "./OverdueStatus";
// import CircularInitial from "../../UpcomingRent/CircularInitial";
// import WhatsAppComponent from "./WhatsappComponent";
// import PaidModal from "./PaidModal";
// import ReportDetails from "./ReportDetails";
// import FilterBuildingModal from "../../Properties/FilterBuildingModal";
// import UnitModal from "./UnitModal";
// import TenantModal from "./TenantModal";
// import Lottie from "lottie-react";
// import loaderAnimation from "../../../assets/animations/loader.json";

// // 🔥 IMPORT ICONS
// import { BsFilterSquare } from "react-icons/bs";
// import { IoMdArrowDropdown } from "react-icons/io";
// import { FaChevronDown, FaChevronUp } from "react-icons/fa";

// // 🔥 IMPORT API UTILITIES
// import APICall from "../../../Utility/APICall";
// import { paths } from "../../../Utility/Constants";

// // IMPORT CONTEXTS
// import { useBuildings } from "../../../Contexts/BuildingContext";
// import { useUnits } from "../../../Contexts/UnitContext";
// import { useTenantContext } from "../../Tenants/TenantContext";

// // 🔥 1. IMPORT THE REUSABLE FILTERS COMPONENT
// import Filters from "../../Common/Filter"; // Adjust path if necessary

// import "./rentoverviewtable.css";

// function RentOverviewTable() {
//   const { jwt } = useAuth();
//   const settings = useSettings();

//   // 🔥 USE REPORTS CONTEXT
//   const reportsData = useReportsData();
//   const updateReportsData = useUpdateReportsData();

//   //   // 🔥 USE EXISTING CONTEXTS INSTEAD OF LOCAL STATE
//   const {
//     allBuildings,
//     fetchAllBuildings,
//     isLoadingBuildings: buildingsLoading,
//   } = useBuildings();
//   const {
//     allUnits,
//     fetchAllUnits,
//     isLoadingAllUnits: unitsLoading,
//   } = useUnits();

//   const {
//     allTenants,
//     tenantData,
//     fetchAllTenants,
//     isLoadingTenants: tenantsLoading,
//   } = useTenantContext();

//   console.log("Tenants in RentOverviewTable via conntext:", tenantData);

//   // 🔥 ALL STATE VARIABLES
//   const [isMarkAsPaidLoading, setIsMarkAsPaidLoading] = useState(false);
//   const [showReportDetailsModal, setShowReportDetailsModal] = useState(false);
//   const [showPaidModal, setShowPaidModal] = useState(false);
//   const [selectedPaymentType, setSelectedPaymentType] = useState("");
//   const [selectedFile, setSelectedFile] = useState(null);

//   const [filters, setFilters] = useState({
//     overdue: false,
//     today: false,
//     buildingIds: [],
//     unitIds: [],
//     tenantIds: [],
//     searchText: "",
//   });

//   const [isFilteringLoading, setIsFilteringLoading] = useState(false);
//   const [collapsedSections, setCollapsedSections] = useState(new Set());

//   // Modal states
//   const [showBuildingModal, setShowBuildingModal] = useState(false);
//   const [showUnitModal, setShowUnitModal] = useState(false);
//   const [showTenantModal, setShowTenantModal] = useState(false);
//   const [selectedBuildingId, setSelectedBuildingId] = useState(null);
//   const [selectedUnitId, setSelectedUnitId] = useState(null);
//   const [selectedTenantId, setSelectedTenantId] = useState(null);

//   const [selectedTenant, setSelectedTenant] = useState([]);

//   // Helper function to get settings value with fallback
//   const getSettingsValue = (property) => {
//     return settings?.[property] === undefined
//       ? AppSettings.getDefaultValue(property)
//       : settings[property];
//   };

//   // 🔥 ENSURE CONTEXT DATA IS LOADED
//   useEffect(() => {
//     if (jwt) {
//       if (!allBuildings.length && !buildingsLoading) {
//         fetchAllBuildings();
//       }
//       if (!allUnits.length && !unitsLoading) {
//         fetchAllUnits();
//       }
//       if (!tenantData.length && !tenantsLoading) {
//         fetchAllTenants();
//       }
//     }
//   }, [jwt, allBuildings.length, allUnits.length, tenantData.length]);

//   // Initial data fetch
//   useEffect(() => {
//     if (settings) {
//       updateReportsData(Loading.LOADING);
//     }
//   }, [jwt, settings]);

//   // 🔥 ADVANCED FILTERING LOGIC
//   const filteredData = useMemo(() => {
//     if (!reportsData.rentData.all.length) return [];

//     return reportsData.rentData.all
//       .map((section) => ({
//         ...section,
//         data: section.data.filter((item) => {
//           if (filters.overdue && item.due_in !== "Overdue") return false;

//           if (filters.today) {
//             const today = new Date();
//             const dueDate = new Date(item.due_date);
//             if (dueDate.toDateString() !== today.toDateString()) return false;
//           }

//           if (
//             filters.buildingIds.length > 0 &&
//             !filters.buildingIds.includes(item.building_id)
//           ) {
//             return false;
//           }

//           if (
//             filters.unitIds.length > 0 &&
//             !filters.unitIds.includes(item.unit_id)
//           ) {
//             return false;
//           }

//           if (
//             filters.tenantIds.length > 0 &&
//             !filters.tenantIds.includes(item.tenant_id)
//           ) {
//             return false;
//           }

//           if (filters.searchText.trim()) {
//             const searchLower = filters.searchText.toLowerCase();
//             const searchableText =
//               `${item.first_name} ${item.last_name} ${item.unit_name} ${item.building_name} ${item.mobile || ""}`.toLowerCase();
//             if (!searchableText.includes(searchLower)) return false;
//           }

//           return true;
//         }),
//       }))
//       .filter((section) => section.data.length > 0);
//   }, [reportsData.rentData.all, filters]);

//   // 🔥 FILTER STATISTICS
//   const filterStats = useMemo(() => {
//     const totalItems = filteredData.reduce(
//       (sum, section) => sum + section.data.length,
//       0
//     );

//     // 🔥 IMPROVED AMOUNT CALCULATION with validation
//     const totalAmount = filteredData.reduce(
//       (sum, section) =>
//         sum +
//         section.data.reduce((sectionSum, item) => {
//           // Validate and clean amount values
//           let amount = 0;
//           if (
//             item.amount &&
//             typeof item.amount === "number" &&
//             item.amount > 0
//           ) {
//             amount = item.amount;
//           } else if (item.local_amount) {
//             // Extract number from local_amount string (e.g., "₹5,000" -> 5000)
//             const cleanAmount = item.local_amount.replace(/[₹,\s]/g, "");
//             const numAmount = parseFloat(cleanAmount);
//             if (!isNaN(numAmount) && numAmount > 0) {
//               amount = numAmount;
//             }
//           }

//           // Cap individual amounts to prevent unrealistic values
//           const MAX_REASONABLE_AMOUNT = 1000000; // 10 lakhs max per item
//           return sectionSum + Math.min(amount, MAX_REASONABLE_AMOUNT);
//         }, 0),
//       0
//     );

//     const overdueCount = filteredData.reduce(
//       (sum, section) =>
//         sum + section.data.filter((item) => item.due_in === "Overdue").length,
//       0
//     );

//     const todayCount = filteredData.reduce(
//       (sum, section) =>
//         sum +
//         section.data.filter((item) => {
//           const today = new Date();
//           const dueDate = new Date(item.due_date);
//           return dueDate.toDateString() === today.toDateString();
//         }).length,
//       0
//     );

//     return {
//       totalItems,
//       totalAmount: Math.max(0, totalAmount), // Ensure non-negative
//       overdueCount,
//       todayCount,
//       sectionsCount: filteredData.length,
//     };
//   }, [filteredData]);

//   // 🔥 UPDATED Filter Stats Display with better formatting and validation
//   // const FilterStatsDisplay = ({ filterStats }) => {
//   //   // Don't show stats if amounts seem unrealistic
//   //   const isAmountRealistic = filterStats.totalAmount < 100000000; // 10 crores max

//   //   return (
//   //     <div className="text-sm text-gray-600">
//   //       <span className="font-medium">{filterStats.totalItems}</span> items
//   //       {isAmountRealistic && filterStats.totalAmount > 0 && (
//   //         <>
//   //           <span className="mx-2">•</span>
//   //           <span className="font-medium">
//   //             {formatAmount(filterStats.totalAmount)}
//   //           </span>{" "}
//   //           total
//   //         </>
//   //       )}
//   //       {filterStats.overdueCount > 0 && (
//   //         <span className="text-red-600 ml-2">
//   //           • <span className="font-medium">{filterStats.overdueCount}</span>{" "}
//   //           overdue
//   //         </span>
//   //       )}
//   //       {filterStats.todayCount > 0 && (
//   //         <span className="text-orange-600 ml-2">
//   //           • <span className="font-medium">{filterStats.todayCount}</span> due
//   //           today
//   //         </span>
//   //       )}
//   //     </div>
//   //   );
//   // };

//   // 🔥 ACTIVE FILTER COUNT
//   const activeFilterCount = useMemo(() => {
//     let count = 0;
//     if (filters.overdue) count++;
//     if (filters.today) count++;
//     if (filters.buildingIds.length > 0) count++;
//     if (filters.unitIds.length > 0) count++;
//     if (filters.tenantIds.length > 0) count++;
//     if (filters.searchText.trim()) count++;
//     return count;
//   }, [filters]);

//   // 🔥 TOGGLE SECTION COLLAPSE
//   const toggleSectionCollapse = (sectionTitle) => {
//     setCollapsedSections((prev) => {
//       const newSet = new Set(prev);
//       if (newSet.has(sectionTitle)) {
//         newSet.delete(sectionTitle);
//       } else {
//         newSet.add(sectionTitle);
//       }
//       return newSet;
//     });
//   };

//   // 🔥 FILTER HANDLERS
//   const handleFilterChange = (filterType, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [filterType]: value,
//     }));
//   };

//   const handleBuildingFilter = (selectedBuildingIds) => {
//     setFilters((prev) => ({
//       ...prev,
//       buildingIds: selectedBuildingIds,
//     }));
//     setShowBuildingModal(false);
//   };

//   const handleUnitFilter = (selectedUnitIds) => {
//     setFilters((prev) => ({
//       ...prev,
//       unitIds: selectedUnitIds,
//     }));
//     setShowUnitModal(false);
//   };

//   const handleTenantFilter = (selectedTenantIds) => {
//     setFilters((prev) => ({
//       ...prev,
//       tenantIds: selectedTenantIds,
//     }));
//     setShowTenantModal(false);
//   };

//   const clearAllFilters = () => {
//     setFilters({
//       overdue: false,
//       today: false,
//       buildingIds: [],
//       unitIds: [],
//       tenantIds: [],
//       searchText: "",
//     });
//   };

//   const handleSearchChange = (searchText) => {
//     setFilters((prev) => ({
//       ...prev,
//       searchText: searchText,
//     }));
//   };

//   // 🔥 ROW CLICK HANDLER
//   const handleRowClick = (person) => {
//     if (person.mark_as_paid_warning) {
//       alert(
//         "Cannot view details until previous dues for this tenant are cleared."
//       );
//       return;
//     }

//     console.log("person: ", person);
//     setSelectedTenant(person);
//     setShowReportDetailsModal(true);
//   };

//   // 🔥 MARK AS PAID CLICK HANDLER
//   const handleMarkAsPaidClick = (person) => {
//     if (person.mark_as_paid_warning) {
//       alert(
//         "You cannot mark this as paid until previous dues for this tenant are cleared."
//       );
//       return;
//     }

//     setSelectedTenant(person);
//     setShowReportDetailsModal(false);
//     setShowPaidModal(true);
//   };

//   // 🔥 UPDATED MARK AS PAID function with is_last_month parameter
//   const handleMarkAsPaid = async () => {
//     try {
//       setIsMarkAsPaidLoading(true);

//       if (selectedPaymentType === "") {
//         alert("Payment type is required.");
//         return;
//       }

//       let body = {
//         nature: selectedTenant.nature,
//         payment_id: "manual",
//         payment_mode: selectedPaymentType,
//         agreement_id: selectedTenant.agreement_id,
//         building_id: selectedTenant.building_id,
//         unit_id: selectedTenant.unit_id,
//         tenant_id: selectedTenant.tenant_id,
//         amount: selectedTenant.amount,
//         payment_status: "success",
//         type: "deposited",
//         month: selectedTenant.month,
//         year: selectedTenant.year,
//         unit_name: selectedTenant.unit_name,
//         building_name: selectedTenant.building_name,
//         tenant_name: selectedTenant.first_name + " " + selectedTenant.last_name,

//         // 🔥 ADD MISSING is_last_month PARAMETER
//         is_last_month: selectedTenant.is_last_month_in_agreement || false,
//       };

//       if (selectedTenant.description) {
//         body = { ...body, description: selectedTenant.description };
//       }

//       if (selectedFile) {
//         body = { ...body, file: selectedFile };
//       }

//       console.log("🔄 Marking as paid for tenant:", selectedTenant);
//       console.log("📤 Request body with is_last_month:", body);

//       const response = await APICall(
//         "POST",
//         paths.rent.markaspaid,
//         body,
//         undefined,
//         jwt
//       );

//       console.log("📥 Mark as paid response:", response);

//       if (response && response.status === "success") {
//         console.log("✅ Payment marked as paid successfully");

//         // Update local state immediately
//         reportsData.handleMarkAsPaidLocally(selectedTenant);

//         // Close modal and reset state
//         setShowPaidModal(false);
//         setSelectedTenant(null);
//         setSelectedPaymentType("");
//         setSelectedFile(null);

//         // 🔥 CONDITIONAL REFRESH based on settings
//         const shouldAutoRefresh = getSettingsValue(
//           AppSettings.AUTO_REFRESH_AFTER_PAYMENT
//         );
//         if (shouldAutoRefresh !== false) {
//           setTimeout(() => {
//             console.log("🔄 Auto-refreshing data from server...");
//             updateReportsData(Loading.PROGRAMMATIC_REFRESHING);
//           }, 2000);
//         }
//       } else {
//         console.error("❌ Mark as paid failed:", response);
//         alert(
//           `Failed to mark as paid: ${response?.message || "Unknown error"}`
//         );
//       }
//     } catch (error) {
//       console.error("❌ Error in handleMarkAsPaid:", error);
//       alert("Failed to mark as paid. Please try again.");
//     } finally {
//       setIsMarkAsPaidLoading(false);
//     }
//   };

//   // 🔥 UTILITY FUNCTIONS
//   const isToday = (someDate) => {
//     const today = new Date();
//     return (
//       someDate.getDate() === today.getDate() &&
//       someDate.getMonth() === today.getMonth() &&
//       someDate.getFullYear() === today.getFullYear()
//     );
//   };

//   // 🔥 RENT COLLECTION ICON HELPER
//   const getRentCollectionIcon = (item) => {
//     if (item.nature !== "rent") return null;

//     const { is_advance_rent, is_last_month_true, month, year } = item;

//     if (is_advance_rent === true && is_last_month_true === true) {
//       return null;
//     } else if (is_advance_rent === false && is_last_month_true === false) {
//       return (
//         <div className="group relative">
//           <div className="p-1 rounded-full bg-orange-100 cursor-help">
//             <svg
//               className="w-3 h-3 text-orange-600"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
//               />
//             </svg>
//           </div>
//           <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block bg-orange-800 text-white rounded py-2 px-3 z-50 w-64">
//             <div className="font-semibold text-xs">
//               ⚠️ Arrears Rent Collection
//             </div>
//             <div className="mt-1 text-[11px] leading-snug">
//               {month} {year} rent will be collected in the following month
//             </div>
//             <div className="mt-2 text-orange-200 border-t border-orange-600 pt-2 text-[11px] leading-snug">
//               💡 <strong>Recommendation:</strong> Enable "Advance Rent" in
//               agreement settings for better cash flow
//             </div>
//             <div className="absolute top-full right-2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-orange-800"></div>
//           </div>
//         </div>
//       );
//     } else {
//       return (
//         <div className="group relative">
//           <div className="p-1 rounded-full bg-yellow-100 cursor-help">
//             <svg
//               className="w-3 h-3 text-yellow-600"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//               />
//             </svg>
//           </div>
//           <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block bg-yellow-800 text-white rounded py-2 px-3 z-50 w-64">
//             <div className="font-semibold text-xs">ℹ️ Custom Rent Timing</div>
//             <div className="mt-1 text-[11px] leading-snug">
//               {month} {year} rent collection as per agreement settings
//             </div>
//             <div className="mt-2 text-yellow-200 border-t border-yellow-600 pt-2 text-[11px] leading-snug">
//               <strong>Current Settings:</strong>
//               <br />
//               Advance Rent: {is_advance_rent ? "Enabled" : "Disabled"}
//               <br />
//               Is Evacuation Month: {is_last_month_true ? "YES" : "NO"}
//             </div>
//             <div className="absolute top-full right-2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-yellow-800"></div>
//           </div>
//         </div>
//       );
//     }
//   };

//   // 🔥 MAIN RENDER FUNCTION FOR TABLE DATA
//   const renderSectionedData = (dataToRender = filteredData) => {
//     if (reportsData.isLoading && dataToRender.length === 0) {
//       return (
//         <tr>
//           <td colSpan="6" className="text-center py-20">
//             <div className="flex flex-col justify-center items-center">
//               <Lottie
//                 animationData={loaderAnimation}
//                 loop={true}
//                 className="w-20 h-20"
//               />
//               <span className="text-gray-600 mt-2 font-medium">
//                 Loading rent data...
//               </span>
//             </div>
//           </td>
//         </tr>
//       );
//     }

//     if (isFilteringLoading) {
//       return (
//         <tr>
//           <td colSpan="6" className="text-center py-20">
//             <div className="flex flex-col justify-center items-center">
//               <Lottie
//                 animationData={loaderAnimation}
//                 loop={true}
//                 className="w-16 h-16"
//               />
//               <span className="text-gray-600 mt-2 font-medium">
//                 Applying filters...
//               </span>
//             </div>
//           </td>
//         </tr>
//       );
//     }

//     if (dataToRender.length === 0) {
//       return (
//         <tr>
//           <td colSpan="6" className="text-center py-8">
//             <div className="flex flex-col items-center justify-center">
//               <div className="text-gray-400 mb-2">
//                 <svg
//                   className="w-12 h-12"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                   />
//                 </svg>
//               </div>
//               <p className="text-gray-500 font-medium">No records to display</p>
//               <p className="text-gray-400 text-sm mt-1">
//                 Try adjusting your filters or add some rent data
//               </p>
//             </div>
//           </td>
//         </tr>
//       );
//     }

//     return (
//       <React.Fragment>
//         {dataToRender.map((section, sectionIndex) => {
//           const isSectionCollapsed = collapsedSections.has(section.title);

//           return (
//             <React.Fragment key={`section_${sectionIndex}`}>
//               {/* Section Header */}
//               <tr className="bg-gray-100 hover:bg-gray-200 transition-colors">
//                 <td
//                   colSpan="6"
//                   className="px-4 py-3 text-left font-semibold text-gray-700 text-sm border-b-2 cursor-pointer"
//                   onClick={() => toggleSectionCollapse(section.title)}
//                 >
//                   <div className="flex items-center justify-between">
//                     <div className="flex items-center gap-2">
//                       <span>{section.title}</span>
//                       <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
//                         {section.data.length} records
//                       </span>
//                     </div>
//                     {isSectionCollapsed ? (
//                       <FaChevronDown className="w-4 h-4 text-gray-500" />
//                     ) : (
//                       <FaChevronUp className="w-4 h-4 text-gray-500" />
//                     )}
//                   </div>
//                 </td>
//               </tr>

//               {/* Section Data */}
//               {!isSectionCollapsed &&
//                 section.data.map((item, itemIndex) => {
//                   const isDisabled = item.mark_as_paid_warning === true;
//                   const rowTitle = isDisabled
//                     ? "Cannot view details until previous dues for this tenant are cleared."
//                     : "";

//                   const handleRowInteraction = (event) => {
//                     event.stopPropagation();
//                     if (isDisabled) {
//                       alert(
//                         "Cannot view details until previous dues for this tenant are cleared."
//                       );
//                     } else {
//                       handleRowClick(item);
//                     }
//                   };

//                   return (
//                     <tr
//                       key={`${sectionIndex}_${itemIndex}`}
//                       title={rowTitle}
//                       onClick={handleRowInteraction}
//                       className={`border-y transition-colors ${
//                         isDisabled
//                           ? "cursor-help"
//                           : "hover:bg-gray-50 cursor-pointer"
//                       }`}
//                     >
//                       <td className="px-4 py-3 text-sm">{itemIndex + 1}</td>
//                       <td className="px-4 py-3">
//                         <div className="flex justify-start items-center gap-4">
//                           <CircularInitial
//                             firstName={item.first_name}
//                             lastName={item.last_name}
//                           />
//                           <div>
//                             <div className="font-medium text-gray-900">
//                               {`${item.first_name} ${item.last_name}`}
//                             </div>
//                             <div className="text-sm text-gray-500">
//                               {item.nature === "security_deposit"
//                                 ? "Security Deposit"
//                                 : `${item.month} ${item.year}`}
//                             </div>
//                           </div>
//                         </div>
//                       </td>
//                       <td className="px-4 py-3 text-sm whitespace-nowrap">
//                         {`${item.unit_name}, ${item.building_name}`}
//                       </td>
//                       <td className="px-4 py-3 text-sm whitespace-nowrap">
//                         <div>
//                           {new Date(item.due_date).toLocaleDateString()}
//                         </div>
//                         <OverdueStatus
//                           dueDate={item.due_date}
//                           dueIn={item.due_in}
//                         />
//                       </td>
//                       <td className="px-4 py-3 text-sm">
//                         <div className="flex justify-center items-center gap-2">
//                           <Paid
//                             isDisabled={isDisabled}
//                             onPressMarkAsPaid={(event) => {
//                               event.stopPropagation();
//                               handleMarkAsPaidClick(item);
//                             }}
//                             isMarkAsPaidDisabled={isMarkAsPaidLoading}
//                           />
//                           <WhatsAppComponent
//                             selectedTenant={item}
//                             isDisabled={isDisabled}
//                             disabledReason={
//                               "Cannot remind until previous dues are cleared."
//                             }
//                           />
//                         </div>
//                       </td>
//                       <td className="px-4 py-3 text-sm text-center font-medium">
//                         <div className="flex items-center justify-center gap-2">
//                           <span className="text-left">
//                             {item.local_amount || `₹${item.amount}`}
//                           </span>
//                           {/* {getRentCollectionIcon(item)} */}
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//             </React.Fragment>
//           );
//         })}
//       </React.Fragment>
//     );
//   };

//   // 🔥 LEGACY FILTER HANDLERS (for compatibility with existing modals)
//   const toggleFilter = (filterName) => {
//     setIsFilteringLoading(true);

//     if (filterName === "unit") {
//       setShowUnitModal(!showUnitModal);
//     } else if (filterName === "building") {
//       setShowBuildingModal(!showBuildingModal);
//     } else if (filterName === "tenant") {
//       setShowTenantModal(!showTenantModal);
//     } else {
//       setFilters((prev) => ({
//         ...prev,
//         [filterName]: !prev[filterName],
//       }));
//     }

//     // Auto-clear loading state
//     setTimeout(() => setIsFilteringLoading(false), 100);
//   };

//   const handleBuildingSelection = (buildingId) => {
//     setSelectedBuildingId(buildingId);
//     setFilters((prev) => ({
//       ...prev,
//       buildingIds: buildingId ? [buildingId] : [],
//     }));
//     setShowBuildingModal(false);
//   };

//   const handleUnitSelection = (unitId) => {
//     setSelectedUnitId(unitId);
//     setFilters((prev) => ({
//       ...prev,
//       unitIds: unitId ? [unitId] : [],
//     }));
//     setShowUnitModal(false);
//   };

//   const handleTenantSelection = (tenantId) => {
//     setSelectedTenantId(tenantId);
//     setFilters((prev) => ({
//       ...prev,
//       tenantIds: tenantId ? [tenantId] : [],
//     }));
//     setShowTenantModal(false);
//   };

//   const closeBuildingModal = () => {
//     setShowBuildingModal(false);
//   };

//   const handleCloseUnitModal = () => {
//     setShowUnitModal(false);
//   };

//   const handleCloseTenantModal = () => {
//     setShowTenantModal(false);
//   };

//   useEffect(() => {
//     if (filteredData.length > 0) {
//       debugAmountValues(filteredData);
//     }
//   }, [filteredData]);

//   // 🔥 THIS IS THE NEW HANDLER to connect to the reusable Filters component
//   const handleNestedFilterChange = useCallback((newFiltersFromChild) => {
//     setFilters((prev) => ({
//       ...prev, // Keep existing filters like overdue, today, searchText
//       buildingIds: newFiltersFromChild.buildingIds,
//       unitIds: newFiltersFromChild.unitIds,
//       tenantIds: newFiltersFromChild.tenantIds,
//     }));
//   }, []);

//   return (
//     <div className="flex flex-col">
//       {/* 🔥 ENHANCED FILTER SECTION */}
//       <div className="filters-container bg-white rounded-lg shadow-sm border p-4 mb-4">
//         {/* Filter Header */}
//         <div className="flex items-center justify-between mb-4">
//           <div className="flex items-center gap-2">
//             <h3 className="text-lg font-medium">Filters</h3>
//             {activeFilterCount > 0 && (
//               <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
//                 {activeFilterCount} active
//               </span>
//             )}
//           </div>

//           {/* 🔥 USE NEW FILTER STATS COMPONENT */}
//           {/* <FilterStatsDisplay filterStats={filterStats} /> */}

//           {activeFilterCount > 0 && (
//             <button
//               onClick={clearAllFilters}
//               className="text-sm text-red-600 hover:text-red-800"
//             >
//               Clear All
//             </button>
//           )}
//         </div>

//         {/* Search Bar */}
//         <div className="mb-4">
//           <input
//             type="text"
//             placeholder="Search by tenant name, unit, building, or mobile..."
//             value={filters.searchText}
//             onChange={(e) => handleSearchChange(e.target.value)}
//             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//           />
//         </div>

//         {/* Filter Buttons */}
//         <div className="flex flex-wrap items-center gap-2">
//           <button
//             className={`px-3 py-2 text-sm rounded-lg border transition-colors ${
//               filters.overdue
//                 ? "bg-red-500 text-white border-red-500"
//                 : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//             }`}
//             onClick={() => handleFilterChange("overdue", !filters.overdue)}
//           >
//             Overdue{" "}
//             {filterStats.overdueCount > 0 && `(${filterStats.overdueCount})`}
//           </button>

//           <button
//             className={`px-3 py-2 text-sm rounded-lg border transition-colors ${
//               filters.today
//                 ? "bg-yellow-500 text-white border-yellow-500"
//                 : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//             }`}
//             onClick={() => handleFilterChange("today", !filters.today)}
//           >
//             Due Today
//           </button>

//           {/* <Filters onFilterChange={handleNestedFilterChange} /> */}
//           <Filters
//             onFilterChange={handleNestedFilterChange}
//             selectedFilters={{
//               buildingIds: filters.buildingIds,
//               unitIds: filters.unitIds,
//               tenantIds: filters.tenantIds,
//             }}
//           />

//           {/* <button
//             className={`px-3 py-2 text-sm rounded-lg border transition-colors ${
//               filters.buildingIds.length > 0
//                 ? "bg-blue-500 text-white border-blue-500"
//                 : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//             }`}
//             onClick={() => setShowBuildingModal(true)}
//             disabled={buildingsLoading}
//           >
//             Buildings{" "}
//             {filters.buildingIds.length > 0 &&
//               `(${filters.buildingIds.length})`}
//             {buildingsLoading && " ..."}
//           </button>

//           <button
//             className={`px-3 py-2 text-sm rounded-lg border transition-colors ${
//               filters.unitIds.length > 0
//                 ? "bg-green-500 text-white border-green-500"
//                 : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//             }`}
//             onClick={() => setShowUnitModal(true)}
//             disabled={unitsLoading}
//           >
//             Units {filters.unitIds.length > 0 && `(${filters.unitIds.length})`}
//             {unitsLoading && " ..."}
//           </button>

//           <button
//             className={`px-3 py-2 text-sm rounded-lg border transition-colors ${
//               filters.tenantIds.length > 0
//                 ? "bg-purple-500 text-white border-purple-500"
//                 : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//             }`}
//             onClick={() => setShowTenantModal(true)}
//             disabled={tenantsLoading}
//           >
//             Tenants{" "}
//             {filters.tenantIds.length > 0 && `(${filters.tenantIds.length})`}
//             {tenantsLoading && " ..."}
//           </button> */}
//         </div>

//         {/* Active Filters Display */}
//         {/* {(filters.buildingIds.length > 0 ||
//           filters.unitIds.length > 0 ||
//           filters.tenantIds.length > 0) && (
//           <div className="mt-3 flex flex-wrap gap-2">
//             {filters.buildingIds.map((buildingId) => {
//               const building = allBuildings.find(
//                 (b) => b.entity_id === buildingId
//               );
//               return building ? (
//                 <span
//                   key={buildingId}
//                   className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
//                 >
//                   🏢 {building.building_name}
//                   <button
//                     onClick={() =>
//                       handleFilterChange(
//                         "buildingIds",
//                         filters.buildingIds.filter((id) => id !== buildingId)
//                       )
//                     }
//                     className="hover:text-blue-600"
//                   >
//                     ×
//                   </button>
//                 </span>
//               ) : null;
//             })}

//             {filters.unitIds.map((unitId) => {
//               const unit = allUnits.find((u) => u.entity_id === unitId);
//               return unit ? (
//                 <span
//                   key={unitId}
//                   className="inline-flex items-center gap-1 px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full"
//                 >
//                   🏠 {unit.unit_name}
//                   <button
//                     onClick={() =>
//                       handleFilterChange(
//                         "unitIds",
//                         filters.unitIds.filter((id) => id !== unitId)
//                       )
//                     }
//                     className="hover:text-green-600"
//                   >
//                     ×
//                   </button>
//                 </span>
//               ) : null;
//             })}

//             {filters.tenantIds.map((tenantId) => {
//               const tenant = tenantData.find((t) => t.entity_id === tenantId);
//               return tenant ? (
//                 <span
//                   key={tenantId}
//                   className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full"
//                 >
//                   👤 {tenant.first_name} {tenant.last_name}
//                   <button
//                     onClick={() =>
//                       handleFilterChange(
//                         "tenantIds",
//                         filters.tenantIds.filter((id) => id !== tenantId)
//                       )
//                     }
//                     className="hover:text-purple-600"
//                   >
//                     ×
//                   </button>
//                 </span>
//               ) : null;
//             })}
//           </div>
//         )} */}
//       </div>

//       {/* 🔥 TABLE SECTION */}
//       <div className="overflow-x-auto">
//         <table className="min-w-full divide-y divide-gray-200 text-xs">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Sr.No
//               </th>
//               <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Description
//               </th>
//               <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Unit Details
//               </th>
//               <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Date
//               </th>
//               <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Status
//               </th>
//               <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Amount
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {renderSectionedData()}
//           </tbody>
//         </table>
//       </div>

//       {/* 🔥 MODALS */}
//       {showReportDetailsModal && (
//         <ReportDetails
//           tenantData={selectedTenant}
//           onClose={() => setShowReportDetailsModal(false)}
//           onMarkAsPaidClick={handleMarkAsPaidClick}
//         />
//       )}

//       {showPaidModal && (
//         <PaidModal
//           onClose={() => setShowPaidModal(false)}
//           onMarkAsPaid={handleMarkAsPaid}
//           selectedTenant={selectedTenant}
//           setSelectedPaymentType={setSelectedPaymentType}
//           setSelectedFile={setSelectedFile}
//         />
//       )}

//       {/* Legacy Filter Modals (using your existing components) */}
//       {/* <FilterBuildingModal
//         show={showBuildingModal}
//         // handleClose={closeBuildingModal}
//         handleClose={() => setShowBuildingModal(false)}
//         buildings={allBuildings}
//         // selectedBuildingId={selectedBuildingId}
//         selectedBuildingIds={filters.buildingIds}
//         // handleApply={handleBuildingSelection}
//         handleApply={handleBuildingFilter}
//       />

//       <UnitModal
//         show={showUnitModal}
//         // handleClose={handleCloseUnitModal}
//         handleClose={() => setShowUnitModal(false)}
//         units={allUnits}
//         // selectedUnitId={selectedUnitId}
//         selectedUnitIds={filters.unitIds}
//         // handleApply={handleUnitSelection}
//         handleApply={handleUnitFilter}
//       />

//       <TenantModal
//         show={showTenantModal}
//         handleClose={() => setShowTenantModal(false)}
//         // handleClose={handleCloseTenantModal}

//         tenantData={tenantData}
//         // selectedTenantId={selectedTenantId}
//         selectedTenantIds={filters.tenantIds}
//         // handleApply={handleTenantSelection}
//         handleApply={handleTenantFilter}
//       /> */}
//     </div>
//   );
// }

// export default RentOverviewTable;

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useAuth } from "../../../Utility/AuthProvider";
import { useSettings } from "../../../Contexts/SettingsContext";
import { AppSettings } from "../../../Contexts/SettingsContext";
import {
  useReportsData,
  useUpdateReportsData,
  Loading,
  formatAmount,
  debugAmountValues,
} from "../../../Contexts/ReportsContext";

// 🔥 IMPORT ALL REQUIRED COMPONENTS
import Paid from "./Paid";
import OverdueStatus from "./OverdueStatus";
import CircularInitial from "../../UpcomingRent/CircularInitial";
import WhatsAppComponent from "./WhatsappComponent";
import ModalManager from "../../Modals/ModalManager";
import Lottie from "lottie-react";
import loaderAnimation from "../../../assets/animations/loader.json";

// 🔥 IMPORT ICONS
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

// 🔥 IMPORT API UTILITIES
import APICall from "../../../Utility/APICall";
import { paths } from "../../../Utility/Constants";

// IMPORT CONTEXTS
import { useBuildings } from "../../../Contexts/BuildingContext";
import { useUnits } from "../../../Contexts/UnitContext";
import { useTenantContext } from "../../Tenants/TenantContext";

// 🔥 IMPORT THE REUSABLE FILTERS COMPONENT
import Filters from "../../Common/Filter";

import "./rentoverviewtable.css";

function RentOverviewTable() {
  const { jwt } = useAuth();
  const settings = useSettings();

  // 🔥 USE REPORTS CONTEXT
  const reportsData = useReportsData();
  const updateReportsData = useUpdateReportsData();

  // 🔥 USE EXISTING CONTEXTS
  const {
    allBuildings,
    fetchAllBuildings,
    isLoadingBuildings: buildingsLoading,
  } = useBuildings();
  const {
    allUnits,
    fetchAllUnits,
    isLoadingAllUnits: unitsLoading,
  } = useUnits();
  const {
    tenantData,
    fetchAllTenants,
    isLoadingTenants: tenantsLoading,
  } = useTenantContext();

  console.log("Tenants in RentOverviewTable via context:", tenantData);

  // 🔥 OPTIMIZED STATE MANAGEMENT
  const [isMarkAsPaidLoading, setIsMarkAsPaidLoading] = useState(false);

  // 🔥 SIMPLIFIED MODAL STATE - Only need these for ModalManager
  const [showReportDetailsModal, setShowReportDetailsModal] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);

  // 🔥 FILTER STATE
  const [filters, setFilters] = useState({
    overdue: false,
    today: false,
    buildingIds: [],
    unitIds: [],
    tenantIds: [],
    searchText: "",
  });

  const [isFilteringLoading, setIsFilteringLoading] = useState(false);
  const [collapsedSections, setCollapsedSections] = useState(new Set());

  // 🔥 OPTIMIZED: Memoized settings getter
  const getSettingsValue = useCallback(
    (property) => {
      return settings?.[property] === undefined
        ? AppSettings.getDefaultValue(property)
        : settings[property];
    },
    [settings]
  );

  // 🔥 ENSURE CONTEXT DATA IS LOADED
  useEffect(() => {
    if (jwt) {
      if (!allBuildings.length && !buildingsLoading) {
        fetchAllBuildings();
      }
      if (!allUnits.length && !unitsLoading) {
        fetchAllUnits();
      }
      if (!tenantData.length && !tenantsLoading) {
        fetchAllTenants();
      }
    }
  }, [jwt, allBuildings.length, allUnits.length, tenantData.length]);

  // Initial data fetch
  useEffect(() => {
    if (settings) {
      updateReportsData(Loading.LOADING);
    }
  }, [jwt, settings, updateReportsData]);

  // 🔥 OPTIMIZED FILTERING LOGIC - Added dependency optimization
  const filteredData = useMemo(() => {
    if (!reportsData.rentData.all.length) return [];

    return reportsData.rentData.all
      .map((section) => ({
        ...section,
        data: section.data.filter((item) => {
          // Early returns for better performance
          if (filters.overdue && item.due_in !== "Overdue") return false;

          if (filters.today) {
            const today = new Date();
            const dueDate = new Date(item.due_date);
            if (dueDate.toDateString() !== today.toDateString()) return false;
          }

          if (
            filters.buildingIds.length > 0 &&
            !filters.buildingIds.includes(item.building_id)
          ) {
            return false;
          }

          if (
            filters.unitIds.length > 0 &&
            !filters.unitIds.includes(item.unit_id)
          ) {
            return false;
          }

          if (
            filters.tenantIds.length > 0 &&
            !filters.tenantIds.includes(item.tenant_id)
          ) {
            return false;
          }

          if (filters.searchText.trim()) {
            const searchLower = filters.searchText.toLowerCase();
            const searchableText =
              `${item.first_name} ${item.last_name} ${item.unit_name} ${item.building_name} ${item.mobile || ""}`.toLowerCase();
            if (!searchableText.includes(searchLower)) return false;
          }

          return true;
        }),
      }))
      .filter((section) => section.data.length > 0);
  }, [reportsData.rentData.all, filters]);

  // 🔥 OPTIMIZED FILTER STATISTICS
  const filterStats = useMemo(() => {
    const totalItems = filteredData.reduce(
      (sum, section) => sum + section.data.length,
      0
    );

    const totalAmount = filteredData.reduce(
      (sum, section) =>
        sum +
        section.data.reduce((sectionSum, item) => {
          let amount = 0;
          if (
            item.amount &&
            typeof item.amount === "number" &&
            item.amount > 0
          ) {
            amount = item.amount;
          } else if (item.local_amount) {
            const cleanAmount = item.local_amount.replace(/[₹,\s]/g, "");
            const numAmount = parseFloat(cleanAmount);
            if (!isNaN(numAmount) && numAmount > 0) {
              amount = numAmount;
            }
          }
          const MAX_REASONABLE_AMOUNT = 1000000;
          return sectionSum + Math.min(amount, MAX_REASONABLE_AMOUNT);
        }, 0),
      0
    );

    const overdueCount = filteredData.reduce(
      (sum, section) =>
        sum + section.data.filter((item) => item.due_in === "Overdue").length,
      0
    );

    const todayCount = filteredData.reduce(
      (sum, section) =>
        sum +
        section.data.filter((item) => {
          const today = new Date();
          const dueDate = new Date(item.due_date);
          return dueDate.toDateString() === today.toDateString();
        }).length,
      0
    );

    return {
      totalItems,
      totalAmount: Math.max(0, totalAmount),
      overdueCount,
      todayCount,
      sectionsCount: filteredData.length,
    };
  }, [filteredData]);

  // 🔥 OPTIMIZED ACTIVE FILTER COUNT
  const activeFilterCount = useMemo(() => {
    let count = 0;
    if (filters.overdue) count++;
    if (filters.today) count++;
    if (filters.buildingIds.length > 0) count++;
    if (filters.unitIds.length > 0) count++;
    if (filters.tenantIds.length > 0) count++;
    if (filters.searchText.trim()) count++;
    return count;
  }, [filters]);

  // 🔥 OPTIMIZED TOGGLE SECTION COLLAPSE
  const toggleSectionCollapse = useCallback((sectionTitle) => {
    setCollapsedSections((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(sectionTitle)) {
        newSet.delete(sectionTitle);
      } else {
        newSet.add(sectionTitle);
      }
      return newSet;
    });
  }, []);

  // 🔥 OPTIMIZED FILTER HANDLERS
  const handleFilterChange = useCallback((filterType, value) => {
    setFilters((prev) => ({ ...prev, [filterType]: value }));
  }, []);

  const handleNestedFilterChange = useCallback((newFiltersFromChild) => {
    setFilters((prev) => ({
      ...prev,
      buildingIds: newFiltersFromChild.buildingIds,
      unitIds: newFiltersFromChild.unitIds,
      tenantIds: newFiltersFromChild.tenantIds,
    }));
  }, []);

  const clearAllFilters = useCallback(() => {
    setFilters({
      overdue: false,
      today: false,
      buildingIds: [],
      unitIds: [],
      tenantIds: [],
      searchText: "",
    });
  }, []);

  const handleSearchChange = useCallback((searchText) => {
    setFilters((prev) => ({ ...prev, searchText }));
  }, []);

  // 🔥 SIMPLIFIED ROW CLICK HANDLER FOR MODALMANAGER
  const handleRowClick = useCallback((person) => {
    if (person.mark_as_paid_warning) {
      alert(
        "Cannot view details until previous dues for this tenant are cleared."
      );
      return;
    }

    console.log("🔄 Opening ReportDetails for:", person);
    setSelectedTenant(person);
    setShowReportDetailsModal(true);
  }, []);

  // 🔥 NEW: HANDLER FOR MODALMANAGER SUCCESS
  const handleMarkAsPaidSuccess = useCallback(
    (tenantData) => {
      console.log("✅ Payment marked as paid successfully for:", tenantData);

      // Update local data using context
      if (reportsData.handleMarkAsPaidLocally) {
        reportsData.handleMarkAsPaidLocally(tenantData);
      }

      // Optional: Auto-refresh based on settings
      const shouldAutoRefresh = getSettingsValue(
        AppSettings.AUTO_REFRESH_AFTER_PAYMENT
      );
      if (shouldAutoRefresh !== false) {
        setTimeout(() => {
          console.log("🔄 Auto-refreshing data from server...");
          updateReportsData(Loading.PROGRAMMATIC_REFRESHING);
        }, 2000);
      }
    },
    [reportsData, getSettingsValue, updateReportsData]
  );

  // 🔥 NEW: HANDLER FOR CLOSING ALL MODALS
  const handleCloseAllModals = useCallback(() => {
    console.log("🔙 Closing all modals");
    setShowReportDetailsModal(false);
    setSelectedTenant(null);
  }, []);

  // 🔥 OPTIMIZED: Memoized utility functions
  const isToday = useCallback((someDate) => {
    const today = new Date();
    return (
      someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
    );
  }, []);

  // 🔥 OPTIMIZED RENT COLLECTION ICON HELPER
  const getRentCollectionIcon = useCallback((item) => {
    if (item.nature !== "rent") return null;

    const { is_advance_rent, is_last_month_true, month, year } = item;

    if (is_advance_rent === true && is_last_month_true === true) {
      return null;
    } else if (is_advance_rent === false && is_last_month_true === false) {
      return (
        <div className="group relative">
          <div className="p-1 rounded-full bg-orange-100 cursor-help">
            <svg
              className="w-3 h-3 text-orange-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block bg-orange-800 text-white rounded py-2 px-3 z-50 w-64">
            <div className="font-semibold text-xs">
              ⚠️ Arrears Rent Collection
            </div>
            <div className="mt-1 text-[11px] leading-snug">
              {month} {year} rent will be collected in the following month
            </div>
            <div className="mt-2 text-orange-200 border-t border-orange-600 pt-2 text-[11px] leading-snug">
              💡 <strong>Recommendation:</strong> Enable "Advance Rent" in
              agreement settings for better cash flow
            </div>
            <div className="absolute top-full right-2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-orange-800"></div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="group relative">
          <div className="p-1 rounded-full bg-yellow-100 cursor-help">
            <svg
              className="w-3 h-3 text-yellow-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block bg-yellow-800 text-white rounded py-2 px-3 z-50 w-64">
            <div className="font-semibold text-xs">ℹ️ Custom Rent Timing</div>
            <div className="mt-1 text-[11px] leading-snug">
              {month} {year} rent collection as per agreement settings
            </div>
            <div className="mt-2 text-yellow-200 border-t border-yellow-600 pt-2 text-[11px] leading-snug">
              <strong>Current Settings:</strong>
              <br />
              Advance Rent: {is_advance_rent ? "Enabled" : "Disabled"}
              <br />
              Is Evacuation Month: {is_last_month_true ? "YES" : "NO"}
            </div>
            <div className="absolute top-full right-2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-yellow-800"></div>
          </div>
        </div>
      );
    }
  }, []);

  // 🔥 OPTIMIZED RENDER FUNCTION
  const renderSectionedData = useCallback(
    (dataToRender = filteredData) => {
      if (reportsData.isLoading && dataToRender.length === 0) {
        return (
          <tr>
            <td colSpan="6" className="text-center py-20">
              <div className="flex flex-col justify-center items-center">
                <Lottie
                  animationData={loaderAnimation}
                  loop={true}
                  className="w-20 h-20"
                />
                <span className="text-gray-600 mt-2 font-medium">
                  Loading rent data...
                </span>
              </div>
            </td>
          </tr>
        );
      }

      if (isFilteringLoading) {
        return (
          <tr>
            <td colSpan="6" className="text-center py-20">
              <div className="flex flex-col justify-center items-center">
                <Lottie
                  animationData={loaderAnimation}
                  loop={true}
                  className="w-16 h-16"
                />
                <span className="text-gray-600 mt-2 font-medium">
                  Applying filters...
                </span>
              </div>
            </td>
          </tr>
        );
      }

      if (dataToRender.length === 0) {
        return (
          <tr>
            <td colSpan="6" className="text-center py-8">
              <div className="flex flex-col items-center justify-center">
                <div className="text-gray-400 mb-2">
                  <svg
                    className="w-12 h-12"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <p className="text-gray-500 font-medium">
                  No records to display
                </p>
                <p className="text-gray-400 text-sm mt-1">
                  Try adjusting your filters or add some rent data
                </p>
              </div>
            </td>
          </tr>
        );
      }

      return (
        <React.Fragment>
          {dataToRender.map((section, sectionIndex) => {
            const isSectionCollapsed = collapsedSections.has(section.title);

            return (
              <React.Fragment key={`section_${sectionIndex}`}>
                {/* Section Header */}
                <tr className="bg-gray-100 hover:bg-gray-200 transition-colors">
                  <td
                    colSpan="6"
                    className="px-4 py-3 text-left font-semibold text-gray-700 text-sm border-b-2 cursor-pointer"
                    onClick={() => toggleSectionCollapse(section.title)}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span>{section.title}</span>
                        <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                          {section.data.length} records
                        </span>
                      </div>
                      {isSectionCollapsed ? (
                        <FaChevronDown className="w-4 h-4 text-gray-500" />
                      ) : (
                        <FaChevronUp className="w-4 h-4 text-gray-500" />
                      )}
                    </div>
                  </td>
                </tr>

                {/* Section Data */}
                {!isSectionCollapsed &&
                  section.data.map((item, itemIndex) => {
                    const isDisabled = item.mark_as_paid_warning === true;
                    const rowTitle = isDisabled
                      ? "Cannot view details until previous dues for this tenant are cleared."
                      : "";

                    const handleRowInteraction = (event) => {
                      event.stopPropagation();
                      if (isDisabled) {
                        alert(
                          "Cannot view details until previous dues for this tenant are cleared."
                        );
                      } else {
                        handleRowClick(item);
                      }
                    };

                    // 🔥 OPTIMIZED: Direct mark as paid handler
                    const handleMarkAsPaidClick = (event) => {
                      event.stopPropagation();
                      if (item.mark_as_paid_warning) {
                        alert(
                          "You cannot mark this as paid until previous dues for this tenant are cleared."
                        );
                        return;
                      }
                      // Open ReportDetails first, ModalManager will handle the flow
                      handleRowClick(item);
                    };

                    return (
                      <tr
                        key={`${sectionIndex}_${itemIndex}`}
                        title={rowTitle}
                        onClick={handleRowInteraction}
                        className={`border-y transition-colors ${
                          isDisabled
                            ? "cursor-help"
                            : "hover:bg-gray-50 cursor-pointer"
                        }`}
                      >
                        <td className="px-4 py-3 text-sm">{itemIndex + 1}</td>
                        <td className="px-4 py-3">
                          <div className="flex justify-start items-center gap-4">
                            <CircularInitial
                              firstName={item.first_name}
                              lastName={item.last_name}
                            />
                            <div>
                              <div className="font-medium text-gray-900">
                                {`${item.first_name} ${item.last_name}`}
                              </div>
                              <div className="text-sm text-gray-500">
                                {item.nature === "security_deposit"
                                  ? "Security Deposit"
                                  : `${item.month} ${item.year}`}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm whitespace-nowrap">
                          {`${item.unit_name}, ${item.building_name}`}
                        </td>
                        <td className="px-4 py-3 text-sm whitespace-nowrap">
                          <div>
                            {new Date(item.due_date).toLocaleDateString()}
                          </div>
                          <OverdueStatus
                            dueDate={item.due_date}
                            dueIn={item.due_in}
                          />
                        </td>
                        <td className="px-4 py-3 text-sm">
                          <div className="flex justify-center items-center gap-2">
                            <Paid
                              isDisabled={isDisabled}
                              onPressMarkAsPaid={handleMarkAsPaidClick}
                              isMarkAsPaidDisabled={isMarkAsPaidLoading}
                            />
                            <WhatsAppComponent
                              selectedTenant={item}
                              isDisabled={isDisabled}
                              disabledReason={
                                "Cannot remind until previous dues are cleared."
                              }
                            />
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-center font-medium">
                          <div className="flex items-center justify-center gap-2">
                            <span className="text-left">
                              {item.local_amount || `₹${item.amount}`}
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </React.Fragment>
            );
          })}
        </React.Fragment>
      );
    },
    [
      filteredData,
      reportsData.isLoading,
      isFilteringLoading,
      collapsedSections,
      toggleSectionCollapse,
      handleRowClick,
      isMarkAsPaidLoading,
    ]
  );

  // 🔥 DEBUGGING EFFECT
  useEffect(() => {
    if (filteredData.length > 0) {
      debugAmountValues(filteredData);
    }
  }, [filteredData]);

  return (
    <div className="flex flex-col">
      {/* 🔥 ENHANCED FILTER SECTION */}
      <div className="filters-container bg-white rounded-lg shadow-sm border p-4 mb-4">
        {/* Filter Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <h3 className="text-lg font-medium">Filters</h3>
            {activeFilterCount > 0 && (
              <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                {activeFilterCount} active
              </span>
            )}
          </div>

          {activeFilterCount > 0 && (
            <button
              onClick={clearAllFilters}
              className="text-sm text-red-600 hover:text-red-800"
            >
              Clear All
            </button>
          )}
        </div>

        {/* Search Bar */}
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search by tenant name, unit, building, or mobile..."
            value={filters.searchText}
            onChange={(e) => handleSearchChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap items-center gap-2">
          <button
            className={`px-3 py-2 text-sm rounded-lg border transition-colors ${
              filters.overdue
                ? "bg-red-500 text-white border-red-500"
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
            }`}
            onClick={() => handleFilterChange("overdue", !filters.overdue)}
          >
            Overdue{" "}
            {filterStats.overdueCount > 0 && `(${filterStats.overdueCount})`}
          </button>

          <button
            className={`px-3 py-2 text-sm rounded-lg border transition-colors ${
              filters.today
                ? "bg-yellow-500 text-white border-yellow-500"
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
            }`}
            onClick={() => handleFilterChange("today", !filters.today)}
          >
            Due Today
          </button>

          <Filters
            onFilterChange={handleNestedFilterChange}
            selectedFilters={{
              buildingIds: filters.buildingIds,
              unitIds: filters.unitIds,
              tenantIds: filters.tenantIds,
            }}
          />
        </div>
      </div>

      {/* 🔥 TABLE SECTION */}
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 text-xs">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Sr.No
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Description
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Unit Details
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Date
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Amount
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {renderSectionedData()}
          </tbody>
        </table>
      </div>

      {/* 🔥 NEW: MODAL MANAGER INTEGRATION */}
      <ModalManager
        isReportDetailsOpen={showReportDetailsModal}
        selectedTenantData={selectedTenant}
        onCloseAll={handleCloseAllModals}
        onMarkAsPaidSuccess={handleMarkAsPaidSuccess}
      />
    </div>
  );
}

export default RentOverviewTable;
